module.exports = __webpack_public_path__ + "static/media/information.1b3b621f.svg";